<div class="heading py-5">
  <h1 class="bold font-curve-large">Forms checkbox</h1>
  <app-dependency-link documentationPath="forms/checks-radios/#checks"></app-dependency-link>
</div>

<section>
  <app-form-check-demo></app-form-check-demo>
</section>
<code
  class="block"
  [highlight]="codeTemplate"
  [languages]="['html', 'scss', 'css', 'typescript', 'javascript']"
></code>
